/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TextTypeImpl } from './text-type';
var MaskedTextTypeImpl = /** @class */ (function (_super) {
    __extends(MaskedTextTypeImpl, _super);
    function MaskedTextTypeImpl(defenition) {
        var _this = _super.call(this, defenition) || this;
        _this.mask = defenition.mask;
        return _this;
    }
    return MaskedTextTypeImpl;
}(TextTypeImpl));
export { MaskedTextTypeImpl };
